import React from "react";
import Modal from "react-modal";

// Este setAppElement debería estar una sola vez en toda tu app, normalmente en index.js
Modal.setAppElement("#root");

function ModalLg({ isOpen, toggleModal, children }) {
  const customStyles = {
    overlay: {
      backgroundColor: "rgb(84 84 84 / 50%)",
      zIndex: 10000, // Asegúrate de que sea mayor que el otro modal si se solapan
    },
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "1024px",
      maxHeight: "90vh", // evita que sobresalga de la pantalla
      overflowY: "auto", // permite scroll si se pasa
      borderRadius: "1rem",
      border: "1px solid #dcdcdc",
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={toggleModal}
      contentLabel="General Modal"
      style={customStyles}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
    >
      {children}
    </Modal>
  );
}

export default ModalLg;
